export default __webpack_public_path__ + "static/media/default-machine.bb37dcbe.jpg";